import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { classNamesConfig } from '../../../Shared/features/classnames';
import { slugify } from '../../../Shared/utils/string';
import { Block } from './library/container';
import { ExpandItem } from './library/expandItem';
class Expander extends React.Component {
    render() {
        return ExpandItem({
            key: this.props.title,
            title: this.props.title,
            text: this.props.text
        });
    }
    constructor(props){
        super(props);
    }
}
export const ExpandersBlock = (props)=>{
    const classNames = classNamesConfig().expanders;
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("section", {
            className: `block block--expand ${classNames.block}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `block__inner ${classNames.inner}`,
                children: [
                    props.title != '' && /*#__PURE__*/ _jsx("header", {
                        "data-anchor": slugify(props.title),
                        className: "block__header",
                        children: /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l container--xs",
                            children: props.title
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "block__content",
                        children: /*#__PURE__*/ _jsx("ul", {
                            className: "block__list expand__list",
                            children: props.entries.map((text, title)=>/*#__PURE__*/ _jsx(Expander, {
                                    title: title,
                                    text: text
                                }, title)).valueSeq().toArray()
                        })
                    })
                ]
            })
        })
    });
};
{
/* TH: Added to styleguide! */ }